import React from 'react'
import PropTypes from 'prop-types'
import ContactAgentGeneric from 'Components/ContactAgentGeneric'
import ShowOnVisible from 'Components/ShowOnVisible'
import Collapsible from 'Components/Collapsible'
import { _AgentBlockContainer, _InsightAgentContainer } from './styles'

const InsightAgent = ({
  buildingName,
  agent,
  handleContactAgentClick,
  collapsibleIdSuffix,
}) => {
  if(!agent) return null
  return (
    <Collapsible
      inputId={`buildingExpert-${collapsibleIdSuffix}`}
      title={`Meet the ${buildingName} building expert`}
      seoText={
        'Message us to learn more about a building or listing, even if you are “just browsing”.'
      }
      gaActionTitle="Building expert"
    >
      <ShowOnVisible>
        <_InsightAgentContainer>
          <_AgentBlockContainer>
            <ContactAgentGeneric
              agent={agent}
              handleContactAgent={handleContactAgentClick}
              gaCategory={'Building'}
            />
          </_AgentBlockContainer>
        </_InsightAgentContainer>
      </ShowOnVisible>
    </Collapsible>
  )
}
InsightAgent.propTypes = {
  buildingName: PropTypes.string,
  agent: PropTypes.shape({
    fullname: PropTypes.string,
  }),
  handleContactAgentClick: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
}
export default InsightAgent
